import AuthGuard from './Auth';

export default AuthGuard;
